export const getLayoutIcon = (itemName) => {
    const nameInt = parseInt(itemName);
    const nameLow = itemName.toLowerCase();
    let iconName = 'error';
    if (!isNaN(nameInt)) {
        iconName = nameInt === 7 ? '7-hexagon' : `${nameInt}-horizontal`;
    }
    else if (nameLow.includes('piece') || nameLow.includes('framed')) {
        iconName = nameLow === '7 piece'
            ? '7-hexagon'
            : nameLow.replace(' piece', '').replace(' ', '-') + '-horizontal';
    }
    else {
        switch (nameLow) {
            case 'horizontal':
            case 'canvas':
                iconName = '1-horizontal';
                break;
            case 'square':
                iconName = '1-square';
                break;
            case 'vertical':
                iconName = '1-vertical';
                break;
            case 'panoramic':
                iconName = '1-panoramic';
                break;
            case 'hexagon':
                iconName = '7-hexagon';
                break;
            case 'multiple':
                iconName = '3-horizontal';
                break;
            case 'poster print':
                iconName = 'poster-horizontal-up';
                break;
        }
    }
    return 'icon__layout_' + iconName;
};
